import { hiddenSanityProductFilterKeys } from '@gelato-api-ui/core/sanity/constants/hidden-sanity-product-filter-keys';
import { mapProductFilterKeyToControlKey } from '@gelato-api-ui/core/sanity/helpers/mapSanityProductResponse';

export const hiddenSanityProductControlKeys = hiddenSanityProductFilterKeys.map(key =>
  mapProductFilterKeyToControlKey(key),
);
